import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import reportPayment from 'view/Payment/Report/PaymentReport';
import { saveOnboardingSettingsAction } from 'view/Onboarding/SaveOnboardingSettings/SaveOnboardingSettingsAction';
import ShoppingCartThankYouContainer from './ShoppingCartThankYouContainerNotConnected';

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
    authLoginByToken: token => global.localStorage.setItem('token', token),
    saveOnboardingSettings: () => dispatch(saveOnboardingSettingsAction()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(
    withRouter(props => (
        <ShoppingCartThankYouContainer
            token={props.match.params.token}
            reportPayment={reportPayment}
            authLoginByToken={props.authLoginByToken}
            saveOnboardingSettings={props.saveOnboardingSettings}
        />
    ))
);
